import { render, staticRenderFns } from "./ManageAgents.vue?vue&type=template&id=535371c6&scoped=true"
import script from "./ManageAgents.vue?vue&type=script&lang=js"
export * from "./ManageAgents.vue?vue&type=script&lang=js"
import style0 from "./ManageAgents.vue?vue&type=style&index=0&id=535371c6&prod&lang=css"
import style1 from "./ManageAgents.vue?vue&type=style&index=1&id=535371c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535371c6",
  null
  
)

export default component.exports